import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "If a CTC filter network is applied, we are able to reproduce a binaural signal via loudspeakers. In this example we demonstrate how the left binaural signal reaches the left ear.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/21/principle/principle-1.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
